import { AssetType } from './RawAsset';

enum AppEnum {
  PAINTER = 'Substance 3D Painter',
  DESIGNER = 'Substance 3D Designer',
  SAMPLER = 'Substance 3D Sampler',
  STAGER = 'Substance 3D Stager',
  MODELER = 'Substance 3D Modeler',
  PHOTOSHOP = 'Adobe Photoshop',
  ILLUSTRATOR = 'Adobe Illustrator',
  BRIDGE = 'Adobe Bridge',
  OTHER = 'Application outside Adobe'
}

const MATERIAL_COMPATIBLE_APPS = [
  AppEnum.PAINTER,
  AppEnum.DESIGNER,
  AppEnum.SAMPLER,
  AppEnum.STAGER,
  AppEnum.MODELER,
  AppEnum.PHOTOSHOP,
  AppEnum.ILLUSTRATOR,
  AppEnum.BRIDGE,
  AppEnum.OTHER
];

const CompatibleApplicationsByAssetType = {
  [AssetType.MATERIAL]: MATERIAL_COMPATIBLE_APPS,
  [AssetType.ATLAS]: MATERIAL_COMPATIBLE_APPS,
  [AssetType.DECAL]: MATERIAL_COMPATIBLE_APPS,
  [AssetType.SMART_MATERIAL]: [AppEnum.PAINTER],
  [AssetType.MODEL]: [AppEnum.MODELER],
  [AssetType.FILTER]: [AppEnum.PAINTER, AppEnum.DESIGNER, AppEnum.SAMPLER],
  [AssetType.TEXTURE_GENERATOR]: [AppEnum.PAINTER],
  [AssetType.MESH_BASED_GENERATOR]: [AppEnum.PAINTER],
  [AssetType.IBL]: [AppEnum.DESIGNER, AppEnum.SAMPLER, AppEnum.STAGER]
};

export { AppEnum, CompatibleApplicationsByAssetType };
